const zIndex = {
  Modal: 99,
  Header: 98,
  SubHeader: 97,
  Base: 0,
};

export default zIndex;
